import * as ExcelJS from "exceljs";

/**
 * Logo JustUp complet (texte + arc), version "dark" pour fond blanc Excel.
 * Le SVG d'origine a le texte en #FFFFFF (pour fond sombre dans l'app),
 * ici on force le texte en #1B2A4A et on conserve l'arc en #05FFAD.
 */
const LOGO_SVG = `<svg viewBox="0 0 120 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M65.9075 31.2531V13.4423H70.6935V31.2531H65.9075ZM59.925 14.0292V9.83325H76.7052V14.0292H59.925Z" fill="#1B2A4A"/>
  <path d="M50.2221 31.8106C48.296 31.8106 46.6715 31.5074 45.3485 30.901C44.0256 30.275 43.0236 29.4339 42.3427 28.3776C41.6618 27.3017 41.3213 26.0693 41.3213 24.6804H45.9614C45.9614 25.2282 46.1073 25.7368 46.3991 26.2062C46.7104 26.6757 47.1773 27.0572 47.7999 27.3506C48.4225 27.6244 49.2299 27.7614 50.2221 27.7614C51.117 27.7614 51.866 27.644 52.4692 27.4093C53.0723 27.1745 53.5295 26.8518 53.8408 26.441C54.152 26.0106 54.3077 25.5216 54.3077 24.9739C54.3077 24.2892 54.0158 23.7513 53.4322 23.36C52.8485 22.9492 51.905 22.6852 50.6014 22.5678L48.9964 22.4211C46.8758 22.245 45.1832 21.5799 43.9186 20.4258C42.654 19.2717 42.0217 17.7459 42.0217 15.8484C42.0217 14.4791 42.3427 13.2957 42.9847 12.298C43.6462 11.3004 44.5606 10.5375 45.7279 10.0093C46.8952 9.46161 48.2765 9.18774 49.8719 9.18774C51.545 9.18774 52.975 9.48117 54.1618 10.068C55.368 10.6353 56.2921 11.4471 56.9341 12.5034C57.5762 13.5402 57.8972 14.7628 57.8972 16.1712H53.2279C53.2279 15.643 53.1014 15.1638 52.8485 14.7334C52.5956 14.2835 52.2162 13.9216 51.7104 13.6478C51.224 13.3739 50.6112 13.237 49.8719 13.237C49.1715 13.237 48.5781 13.3543 48.0917 13.5891C47.6248 13.8238 47.2746 14.1466 47.0411 14.5574C46.8077 14.9486 46.6909 15.379 46.6909 15.8484C46.6909 16.4548 46.905 16.983 47.333 17.4329C47.761 17.8828 48.4614 18.1469 49.4341 18.2251L51.0684 18.3719C52.6248 18.5088 53.9964 18.8511 55.1832 19.3988C56.3699 19.927 57.2941 20.6606 57.9555 21.5995C58.6365 22.5189 58.9769 23.6437 58.9769 24.9739C58.9769 26.3432 58.617 27.5462 57.8972 28.583C57.1968 29.6001 56.1948 30.3924 54.8913 30.9597C53.5878 31.527 52.0314 31.8106 50.2221 31.8106Z" fill="#1B2A4A"/>
  <path d="M29.0829 31.8106C27.079 31.8106 25.3767 31.4389 23.9759 30.6956C22.5946 29.9327 21.544 28.8568 20.8242 27.4679C20.1043 26.0791 19.7444 24.4359 19.7444 22.5384V9.83325H24.5304V22.7145C24.5304 23.6534 24.7055 24.475 25.0557 25.1792C25.4253 25.8639 25.9409 26.392 26.6024 26.7637C27.2833 27.1354 28.1101 27.3212 29.0829 27.3212C30.0751 27.3212 30.902 27.1354 31.5635 26.7637C32.2444 26.392 32.76 25.8639 33.1102 25.1792C33.4603 24.4946 33.6354 23.673 33.6354 22.7145V9.83325H38.4214V22.5384C38.4214 24.4359 38.0615 26.0791 37.3417 27.4679C36.6218 28.8568 35.5712 29.9327 34.1899 30.6956C32.8086 31.4389 31.1063 31.8106 29.0829 31.8106Z" fill="#1B2A4A"/>
  <path d="M7.8502 31.8106C6.23541 31.8106 4.83463 31.5074 3.64786 30.901C2.48055 30.275 1.57588 29.3752 0.933852 28.2015C0.311284 27.0278 0 25.5998 0 23.9175V22.8319H4.72763V24.1816C4.72763 25.1205 5 25.8834 5.54475 26.4703C6.10895 27.0376 6.87744 27.3212 7.8502 27.3212C8.80351 27.3212 9.55253 27.0376 10.0973 26.4703C10.6615 25.8834 10.9436 25.1205 10.9436 24.1816V13.4423H15.7296V23.9175C15.7296 25.5998 15.4086 27.0278 14.7665 28.2015C14.144 29.3752 13.2393 30.275 12.0525 30.901C10.8852 31.5074 9.48444 31.8106 7.8502 31.8106ZM2.48055 14.0292V9.65723H15.7296V14.0292H2.48055Z" fill="#1B2A4A"/>
  <path d="M107.743 25.1206V20.954H111.566C112.305 20.954 112.938 20.8073 113.463 20.5138C114.008 20.2204 114.426 19.8096 114.718 19.2815C115.01 18.7338 115.156 18.1078 115.156 17.4036C115.156 16.6602 115.01 16.0245 114.718 15.4963C114.426 14.9486 114.008 14.5378 113.463 14.264C112.938 13.9705 112.305 13.8238 111.566 13.8238H107.743V9.65723H111.333C113.142 9.65723 114.689 9.96043 115.973 10.5668C117.276 11.1732 118.269 12.0339 118.949 13.149C119.65 14.264 120 15.6039 120 17.1688V17.6383C120 19.1641 119.65 20.4943 118.949 21.6289C118.269 22.7439 117.276 23.6046 115.973 24.211C114.689 24.8174 113.142 25.1206 111.333 25.1206H107.743ZM103.541 31.2531V9.65723H108.327V31.2531H103.541Z" fill="#1B2A4A"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M80.72 24.0642C80.8864 25.1552 81.1989 26.1431 81.6574 27.0278C82.3773 28.4166 83.4279 29.4925 84.8092 30.2554C86.21 30.9988 87.9123 31.3704 89.9162 31.3704C91.9395 31.3704 93.6419 30.9988 95.0232 30.2554C96.4045 29.4925 97.4551 28.4166 98.175 27.0278C98.6335 26.1431 98.946 25.1552 99.1124 24.0642H94.2182C94.1434 24.3023 94.0518 24.5272 93.9434 24.7391C93.5932 25.4237 93.0777 25.9519 92.3967 26.3236C91.7353 26.6952 90.9084 26.8811 89.9162 26.8811C88.9434 26.8811 88.1166 26.6952 87.4357 26.3236C86.7742 25.9519 86.2586 25.4237 85.889 24.7391C85.7825 24.525 85.6922 24.3 85.6181 24.0642H80.72Z" fill="#05FFAD"/>
  <path d="M90.0767 22.7879C88.0728 22.7879 86.3705 22.4162 84.9697 21.6729C83.5884 20.91 82.5378 19.8341 81.8179 18.4452C81.0981 17.0564 80.7382 15.4132 80.7382 13.5157V0.810547H85.5242V13.6918C85.5242 14.6307 85.6993 15.4523 86.0494 16.1565C86.4191 16.8412 86.9347 17.3693 87.5961 17.741C88.2771 18.1127 89.1039 18.2985 90.0767 18.2985C91.0689 18.2985 91.8958 18.1127 92.5572 17.741C93.2382 17.3693 93.7537 16.8412 94.1039 16.1565C94.4541 15.4719 94.6292 14.6503 94.6292 13.6918V0.810547H99.4152V13.5157C99.4152 15.4132 99.0553 17.0564 98.3354 18.4452C97.6156 19.8341 96.565 20.91 95.1837 21.6729C93.8024 22.4162 92.1 22.7879 90.0767 22.7879Z" fill="#1B2A4A"/>
</svg>`;

const JUSTUP_URL = "https://justup.io";
let cachedLogoPng: string | null = null;

/**
 * Définit toutes les métadonnées JustUp sur le workbook (auteur, société,
 * mots-clés, description, dates). Centralisé ici pour garantir une signature
 * homogène dans **tous** les exports Excel générés par JustUp.
 *
 * Les métadonnées résultantes sont visibles dans Fichier → Propriétés (Excel)
 * ou via `unzip xlsx && cat docProps/core.xml`. Elles servent à identifier
 * la source du fichier sans ambiguïté.
 *
 * @param wb       Workbook ExcelJS (juste après `new ExcelJS.Workbook()`)
 * @param options  Surcharges optionnelles pour `title` / `subject` /
 *                 `description` / `company` / `keywords` selon le contexte
 *                 du document (ex. titre du dossier, nom du tiers, etc.).
 */
export function setJustupMetadata(
  wb: ExcelJS.Workbook,
  options: {
    title?: string;
    subject?: string;
    description?: string;
    company?: string;
    keywords?: string;
  } = {},
): void {
  const now = new Date();
  wb.creator = "JustUp";
  wb.lastModifiedBy = "JustUp";
  wb.created = now;
  wb.modified = now;
  wb.company = options.company ?? "JustUp";
  wb.manager = "JustUp";
  wb.category = "Export JustUp";
  wb.title = options.title ?? "Export JustUp";
  wb.subject = options.subject ?? "Export généré par JustUp";
  wb.description =
    options.description ??
    `Document généré par JustUp — ${JUSTUP_URL}`;
  wb.keywords =
    options.keywords ?? `JustUp, justup.io, ERP, ${JUSTUP_URL}`;
}

async function getLogoPng(): Promise<string | null> {
  if (cachedLogoPng) return cachedLogoPng;
  try {
    const svgBlob = new Blob([LOGO_SVG], {
      type: "image/svg+xml;charset=utf-8",
    });
    const url = URL.createObjectURL(svgBlob);
    const img = await loadImage(url);
    URL.revokeObjectURL(url);

    // viewBox 120×32 → ratio 3.75. On rend à 360×96 pour une bonne netteté.
    const canvas = document.createElement("canvas");
    canvas.width = 360;
    canvas.height = 96;
    const ctx = canvas.getContext("2d");
    if (!ctx) return null;
    ctx.fillStyle = "rgba(0,0,0,0)";
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    cachedLogoPng = canvas
      .toDataURL("image/png")
      .replace(/^data:image\/png;base64,/, "");
    return cachedLogoPng;
  } catch {
    return null;
  }
}

function loadImage(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
}

/**
 * Ajoute une signature JustUp discrète dans le coin supérieur droit de la
 * worksheet. Principe : logo + lien justup.io alignés à droite de la
 * dernière colonne, sur la même ligne que le titre de la feuille.
 *
 * Design volontairement sobre : le but est de signer le document sans
 * concurrencer visuellement le titre ni le contenu.
 *
 * @param wb       Workbook (pour `addImage`)
 * @param ws       Worksheet cible
 * @param lastCol  Dernière colonne utilisée — le branding est placé dedans
 */
export async function addJustupBranding(
  wb: ExcelJS.Workbook,
  ws: ExcelJS.Worksheet,
  lastCol: number,
  options: { logoWidth?: number; logoHeight?: number } = {},
): Promise<void> {
  // Taille par défaut compacte — le logo reste lisible à ce format et ne
  // déborde pas d'une colonne de 12-14 chars (largeur courante en pixels :
  // ~90-100 px). Ajustable via `options` pour les feuilles avec dernière
  // colonne plus large où on peut se permettre un logo lisible.
  const LOGO_W = options.logoWidth ?? 96;
  const LOGO_H = options.logoHeight ?? 26;

  // Cellule de signature : lien « justup.io ↗ » aligné à droite, sobre, sans
  // soulignement pour ne pas alourdir. Le ↗ signale au lecteur que c'est un
  // lien cliquable sans la « vieillesse » du soulignement bleu.
  const brandCell = ws.getCell(1, lastCol);
  brandCell.value = {
    text: "justup.io  ↗",
    hyperlink: JUSTUP_URL,
    tooltip: `Ouvrir ${JUSTUP_URL}`,
  } as any;
  brandCell.font = {
    name: "Calibri",
    size: 9,
    color: { argb: "FF94A3B8" },
    bold: false,
    italic: false,
    underline: false,
  };
  brandCell.alignment = {
    horizontal: "right",
    vertical: "bottom",
    indent: 0,
  };

  // Logo : flottant dans la cellule, en haut à droite. On utilise un
  // positionnement fractionnaire simple (bord droit de la dernière colonne
  // moins une petite marge) pour rester robuste quelle que soit la largeur
  // réelle de la colonne — plus besoin de deviner en pixels.
  try {
    const png = await getLogoPng();
    if (!png) return;
    const imageId = wb.addImage({ base64: png, extension: "png" });

    // Largeur approximative de la dernière colonne en pixels pour calculer
    // la fraction correcte — le logo doit se poser "à l'intérieur" de la
    // cellule, près du bord droit, sans déborder.
    const colWidthChars = ws.columns?.[lastCol - 1]?.width ?? 14;
    const colWidthPx = Math.max(40, colWidthChars * 7 + 5);
    // Marge droite de 6 px pour respirer avant le bord de la cellule.
    const rightMargin = 6;
    const fraction = Math.max(
      0.02,
      (colWidthPx - LOGO_W - rightMargin) / colWidthPx,
    );

    ws.addImage(imageId, {
      tl: { col: lastCol - 1 + fraction, row: 0.1 } as any,
      ext: { width: LOGO_W, height: LOGO_H },
      editAs: "oneCell",
    } as any);
  } catch {
    /* si le logo échoue, le lien texte suffit pour la signature */
  }
}

/**
 * Ajoute un bandeau discret juste sous le titre pour préciser que le calcul
 * est fait hors main-d'œuvre. N'ajoute rien si la MO est intégrée au scénario.
 *
 * À appeler APRÈS `sheetHeaderRow` / le titre de feuille et APRÈS
 * `addJustupBranding` (qui occupe la ligne du titre), mais AVANT les lignes
 * de contenu pour que le message soit visible en haut.
 *
 * @param ws       Worksheet cible
 * @param lastCol  Dernière colonne utilisée (merge horizontal du bandeau)
 * @param includeMO  Vrai si la MO est intégrée au calcul. Sinon → bandeau ajouté.
 */
export function addMoScopeBanner(
  ws: ExcelJS.Worksheet,
  lastCol: number,
  includeMO: boolean,
): void {
  if (includeMO) return;
  // Insertion en row 2 (juste sous le titre) pour que le message soit visible
  // dès l'ouverture de la feuille. `spliceRows(rowNum, 0, [...])` insère sans
  // supprimer, ce qui décale les lignes suivantes d'un cran vers le bas.
  const BANNER_ROW = 2;
  ws.spliceRows(BANNER_ROW, 0, [
    "Périmètre de calcul : coûts matière uniquement — la main-d'œuvre n'est pas intégrée à ce scénario. Tous les coûts, taux et marges affichés sont donc hors MO.",
  ]);
  ws.mergeCells(BANNER_ROW, 1, BANNER_ROW, lastCol);
  ws.getRow(BANNER_ROW).height = 26;
  const cell = ws.getCell(BANNER_ROW, 1);
  cell.font = {
    name: "Calibri",
    size: 10,
    italic: true,
    color: { argb: "FFB45309" },
    bold: true,
  };
  cell.fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FFFFFBEB" },
  };
  cell.alignment = { horizontal: "left", vertical: "middle", wrapText: true, indent: 1 };
  cell.border = {
    top: { style: "thin", color: { argb: "FFFBBF24" } },
    bottom: { style: "thin", color: { argb: "FFFBBF24" } },
  };
}

/**
 * Pose un bandeau d'information sur l'unité utilisée — coûts et marges
 * sont exprimés en €/UG (= unité de production / kilo / unité de gestion),
 * et pour obtenir le prix en €/UV (carton, lot, conditionnement de vente)
 * il faut multiplier par le coefficient UG/UV (col indiquée).
 *
 * À utiliser dans les exports Excel cost-impact pour ne pas tromper
 * l'utilisateur qui penserait lire un prix en €/UV alors qu'il est en €/UG.
 * Inséré sous le bandeau MO si présent (ou directement sous le titre).
 *
 * @param ws       Worksheet cible
 * @param lastCol  Dernière colonne utilisée (merge horizontal du bandeau)
 * @param coefColumnLetter Lettre de la colonne contenant le coefficient
 *                         (ex: "C"). Si absent → message générique sans
 *                         référence colonne.
 */
export function addUnitBanner(
  ws: ExcelJS.Worksheet,
  lastCol: number,
  coefColumnLetter?: string,
): void {
  // Insertion en row 2 (sous le titre). Si addMoScopeBanner a déjà inséré
  // un bandeau MO, celui-ci se retrouve en row 3 — c'est l'ordre voulu :
  // MO (cas) > Unité (toujours utile).
  const BANNER_ROW = 2;
  const text = coefColumnLetter
    ? `Les coûts, marges et prix sont exprimés en €/unité de gestion (UG, ex: kilo, unité produite). Pour obtenir le prix en €/unité de vente (UV, carton…) : multiplier par le coefficient de la colonne ${coefColumnLetter} (= ${coefColumnLetter}). Quand le coefficient vaut 1, UG ≡ UV.`
    : `Les coûts, marges et prix sont exprimés en €/unité de gestion (UG, ex: kilo, unité produite). Pour obtenir le prix en €/unité de vente (UV, carton…) : multiplier par le coefficient UG/UV de l'article. Quand le coefficient vaut 1, UG ≡ UV.`;
  ws.spliceRows(BANNER_ROW, 0, [text]);
  ws.mergeCells(BANNER_ROW, 1, BANNER_ROW, lastCol);
  ws.getRow(BANNER_ROW).height = 32;
  const cell = ws.getCell(BANNER_ROW, 1);
  cell.font = {
    name: "Calibri",
    size: 10,
    italic: true,
    color: { argb: "FF1E40AF" },
    bold: true,
  };
  cell.fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FFEFF6FF" },
  };
  cell.alignment = { horizontal: "left", vertical: "middle", wrapText: true, indent: 1 };
  cell.border = {
    top: { style: "thin", color: { argb: "FF93C5FD" } },
    bottom: { style: "thin", color: { argb: "FF93C5FD" } },
  };
}
